import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { WithPopover } from '@lightspeed/design-system-react'
import { useT } from '@transifex/react'
import classNames from 'classnames'
import { selectSaleFinals } from '../../../state/slices/currentSale/currentSaleSlice'
import { useFormatCurrencyValue } from '../../helpers/formatNumberHooks'
import { useCalculateFinalTaxName } from '../../helpers/useCalculateFinalTaxName'
import { SaleTaxBreakdownPopover } from './SaleTaxBreakdownPopover'
import { useDisplayTax } from './useDisplayTax'

type TaxNameProps = {
  name: string
  onClick?: () => void
}
const TaxName = (props: TaxNameProps) => {
  const { onClick, name } = props
  const cssClass = classNames('vd-text-label', {
    'vd-link': !!onClick,
  })
  const t = useT()
  return (
    <>
      <span className={cssClass} onClick={onClick}>
        {t('Tax', { _context: 'Text' })}
      </span>
      <span className="sale-total-line-item--sub">{name}</span>
    </>
  )
}
/**
 * Sale tax component showing on the sale footer
 */
export const SaleTaxBreakdown = () => {
  const calculateFinalTaxName = useCalculateFinalTaxName()
  const formatCurrencyValue = useFormatCurrencyValue()
  const {
    taxDisplayProperties: { showTaxBreakdown },
    tax,
  } = useSelector(selectSaleFinals)
  const displayTaxes = useDisplayTax()
  const [isOpen, setIsOpen] = useState(false)
  const showPopover = () => setIsOpen(true)
  const closePopover = () => setIsOpen(false)

  const onClickHandler =
    showTaxBreakdown && displayTaxes.length > 0 ? showPopover : undefined

  /**
   * Automatically close the popover when showTaxBreakdown falsy, or displayTaxes are empty
   */
  useEffect(() => {
    if (!showTaxBreakdown || displayTaxes.length === 0) {
      closePopover()
    }
  }, [displayTaxes, showTaxBreakdown])

  return (
    <>
      <div>
        <WithPopover direction="left" alignment="start">
          <TaxName name={calculateFinalTaxName()} onClick={onClickHandler} />
          {isOpen && <SaleTaxBreakdownPopover closePopover={closePopover} />}
        </WithPopover>
      </div>
      <div className="vd-text-label">{formatCurrencyValue(tax)}</div>
    </>
  )
}
